import { Box, Typography } from '@mui/material';
import ContainerFilesTable from './components/ContainerFilesTable';
import { useSearchParams } from 'react-router-dom';

const Files = () => {
  const [searchParams] = useSearchParams();
  const pbmId = searchParams.get('pbmId');
  const fileNameContains = searchParams.get('fileNameContains');
  
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Typography variant="h4" gutterBottom>
          Files
        </Typography>
      </Box>
      <ContainerFilesTable 
        initialFilter={
          pbmId || fileNameContains
            ? {
                pbmName: pbmId || undefined,
                fileNameContains: fileNameContains || undefined
              }
            : undefined
        }
      />
    </Box>
  );
};

export default Files;
